<template>
  <section v-if="result" class="seo-text">
    <SlideUpDown
      v-model="isOpen"
      :use-hidden="false"
      :style="`min-height: ${minHeight > 140 ? '140' : minHeight}px`"
    >
      <DefContent ref="content" v-html="result" />
    </SlideUpDown>
    <span v-if="minHeight > 140" class="seo-text-more" @click="isOpen = !isOpen">
      {{ !isOpen ? messages.readMore : messages.rollUp }}
      <svg class="seo-text-more__icon" :class="{ 'seo-text-more__icon_active': isOpen }">
        <use xlink:href="#svg-arrow-down"></use>
      </svg>
    </span>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import DefContent from '@components/Def/DefContent/DefContent.vue';

export default {
  name: 'SeoText',
  components: { DefContent },
  data() {
    return {
      isOpen: false,
      minHeight: 0,
    };
  },
  computed: {
    ...mapState({
      result: ({ results }) => results?.seoText,
      messages: ({ results }) => results?.messages,
    }),
  },
  mounted() {
    if (this.result) {
      this.handlerResize();
      window.addEventListener('resize', this.handlerResize);
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handlerResize);
  },
  methods: {
    handlerResize() {
      this.minHeight = this.$refs.content.$el.offsetHeight;
    },
  },
};
</script>

<style lang="scss">
.seo-text {
  margin-bottom: 60px;
  @include point-lg {
    margin: 0 auto 80px;
  }
  &__content {
    min-height: 140px;
    font-size: 14px;
    line-height: 150%;
    @include point-md {
      font-size: 16px;
    }
  }
}
.seo-text-more {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: 0.2s linear color;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  color: var(--color-golden-browm);
  margin-top: 16px;
  @include point-md {
    font-size: 16px;
  }
  @include point-lg {
    margin-top: 24px;
  }
  &__icon {
    width: 18px;
    height: 18px;
    margin-left: 4px;
    fill: currentColor;
    transition: 0.2s linear transform;
    &_active {
      transform: rotate(180deg);
    }
  }
}
</style>
